<script>
import SalesAccountToDo from '@/views/Application/Sales/Accounts/Account/ToDo'

export default {
  extends: SalesAccountToDo,
  data () {
    return {
      breadcrumb: {
        name: 'To-Do',
        route: { name: 'sales-opportunities-account-todo', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
